class NavMenuItem {
    constructor(content, icon, link, onNavigate, onLogout = null) {
        this.content = content;
        this.icon = icon;
        this.link = link;
        this.onAction = () => (onLogout ? onLogout() : onNavigate(link));
    }
}

export default NavMenuItem;